const FinanceCategories = () => import('./FinanceCategories.vue')
const FinanceCategoryDetails = () => import('./FinanceCategoryDetails.vue')

export default [
  {
    name: 'finance-categories',
    path: 'finance-categories',
    component: FinanceCategories,
    meta: {
      access: ['org.financeCategory.view']
    },
    children: [
      {
        name: 'finance-category-edit',
        path: ':financeCategoryId/edit',
        components: {
          modal: FinanceCategoryDetails
        },
        meta: {
          showModal: true,
          access: ['org.financeCategory.manage']
        }
      },
      {
        name: 'finance-category-new',
        path: 'new',
        components: {
          modal: FinanceCategoryDetails
        },
        meta: {
          showModal: true,
          access: ['org.financeCategory.manage']
        }
      }
    ]
  }
]
